import styled from 'styled-components'
import { v1 as color, media } from 'sidecar-design-library'

import BaseIcon from '../../IconV1'
import BasePriceFairnessTag from '../../PriceFairnessTag'

export const Wrapper = styled.div`
  position: relative;
  transition: all 0.1s;
  display: flex;
  width: 100%;
`

export const ImageColumn = styled.div`
  margin-right: 0.9375rem;
`

export const ImageWrapper = styled.div`
  width: 3rem;
  height: 3rem;
  border-radius: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;

  img {
    width: 100%;
  }
`

export const IndexLabel = styled.div`
  display: flex;
  font-size: 0.75rem;
  justify-content: center;
  align-items: center;
  color: ${color.WHITE};
  background: ${color.REGAL};
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 1.25rem;
  position: absolute;
  left: 0;
  top: 0;
`

// ----------

export const InfoColumn = styled.div`
  flex-grow: 1;
`

export const Name = styled.div`
  font-size: 1rem;
  line-height: 1.5rem;
  color: ${color.AQUAMARINE};
  overflow: hidden;
  text-overflow: ellipsis;
  overflow-wrap: break-word;
`

export const PriceFairnessSpeciality = styled.div`
  display: flex;
  margin-bottom: 0.3125rem;
`

export const PriceFairnessTag = styled(BasePriceFairnessTag)`
  margin-right: 0.3125rem;
`

export const Specialty = styled.div`
  color: ${color.GREY};
  font-size: 0.875rem;
  line-height: 1.25rem;
`

export const Address = styled.div`
  color: #7f7e7e;
  font-size: 0.875rem;
  line-height: 1.0625rem;
`

// ----------

export const ExtraColumn = styled.div`
  margin-left: 0.9375rem;
  display: flex;
  flex-direction: column;

  ${media.belowDesktop`
    margin-left: 0.625rem;
  `}
`
export const NextIcon = styled(BaseIcon).attrs({
  name: 'forward',
})`
  font-size: 1.5625rem;
  align-self: flex-end;
  color: ${color.AQUAMARINE};
`

export const Cost = styled.span`
  font-size: 1rem;
  line-height: 1.5rem;
  font-family: 'sidecarta-sans-bold';
  white-space: nowrap;
  text-align: right;
`

// ----------
